import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, normalizeClass as _normalizeClass, createVNode as _createVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = { class: "clearfix" };
const _hoisted_2 = { class: "clearfix measurement-filter" };
const _hoisted_3 = /*#__PURE__*/ _createElementVNode("label", { class: "normal" }, "Measurement", -1 /* HOISTED */);
const _hoisted_4 = { class: "btn-group pw100" };
const _hoisted_5 = { class: "measurement-options bottom10" };
const _hoisted_6 = ["onClick"];
const _hoisted_7 = {
    key: 0,
    class: "clearfix"
};
const _hoisted_8 = { class: "d-flex justify-content-start mt-2" };
const _hoisted_9 = { class: "ms-2" };
const _hoisted_10 = /*#__PURE__*/ _createElementVNode("label", { class: "normal" }, "Select All by default", -1 /* HOISTED */);
const _hoisted_11 = {
    class: /*#__PURE__*/ _normalizeClass(['component-tree-wrapper']),
    style: { "max-height": "350px", "height": "350px" }
};
const _hoisted_12 = { class: "component-tree component-tree-small" };
const _hoisted_13 = { class: "float-end float-start-sm" };
const _hoisted_14 = /*#__PURE__*/ _createElementVNode("i", { class: "fa fa-times" }, null, -1 /* HOISTED */);
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_b_button = _resolveComponent("b-button");
    const _component_b_form_input = _resolveComponent("b-form-input");
    const _component_b_input_group_append = _resolveComponent("b-input-group-append");
    const _component_b_input_group = _resolveComponent("b-input-group");
    const _component_b_form_checkbox = _resolveComponent("b-form-checkbox");
    const _component_ComponentTreeVue = _resolveComponent("ComponentTreeVue");
    const _component_b_container = _resolveComponent("b-container");
    const _component_b_modal = _resolveComponent("b-modal");
    const _directive_b_tooltip = _resolveDirective("b-tooltip");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
            _hoisted_3,
            _createTextVNode(),
            _createElementVNode("div", _hoisted_4, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.visibleMeasurementCategories, (category, index) => {
                    return (_openBlock(), _createBlock(_component_b_button, {
                        class: "pw100 tabs",
                        key: category.measurementCategoryId,
                        variant: _ctx.measurementCategory.measurementCategoryName == category.measurementCategoryName ? 'primary' : 'outline-secondary',
                        onClick: ($event) => (_ctx.setMeasurementCategory(category))
                    }, {
                        default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(category.measurementCategoryName), 1 /* TEXT */)
                        ]),
                        _: 2 /* DYNAMIC */
                    }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["variant", "onClick"]));
                }), 128 /* KEYED_FRAGMENT */))
            ]),
            _createTextVNode(),
            _createElementVNode("div", _hoisted_5, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.measurementTypeVisible, (item, itemIdx) => {
                    return (_openBlock(), _createElementBlock("div", {
                        class: _normalizeClass(['measurement-option', _ctx.measurementType == item ? 'selected-option' : '']),
                        onClick: ($event) => (_ctx.setMeasurementType(item))
                    }, [
                        _createElementVNode("div", {
                            class: _normalizeClass(['title', _ctx.measurementType == item ? 'white' : ''])
                        }, _toDisplayString(item.measurementTypeName), 3 /* TEXT, CLASS */)
                    ], 10 /* CLASS, PROPS */, _hoisted_6));
                }), 256 /* UNKEYED_FRAGMENT */))
            ])
        ]),
        _createTextVNode(),
        (_ctx.measurementTypeRequiresNode)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                _createVNode(_component_b_input_group, {
                    class: _normalizeClass(['clearfix bottom0 popup-selection-control', _ctx.areNodesInvalid ? 'is-invalid' : '']),
                    title: _ctx.selectedLocationsTitle,
                    onClick: _cache[0] || (_cache[0] = ($event) => (_ctx.locationsModalVisible = true))
                }, {
                    default: _withCtx(() => [
                        _createVNode(_component_b_form_input, {
                            placeholder: _ctx.selectedLocationsPlaceholder,
                            value: _ctx.selectedLocationsText,
                            readonly: ""
                        }, null, 8 /* PROPS */, ["placeholder", "value"]),
                        _createTextVNode(),
                        _createVNode(_component_b_input_group_append, null, {
                            default: _withCtx(() => [
                                _createVNode(_component_b_button, {
                                    type: "button",
                                    variant: "outline-secondary"
                                }, {
                                    default: _withCtx(() => [
                                        _createTextVNode("\r\n\t\t\t\t\t\t...\r\n\t\t\t\t\t")
                                    ]),
                                    _: 1 /* STABLE */
                                })
                            ]),
                            _: 1 /* STABLE */
                        })
                    ]),
                    _: 1 /* STABLE */
                }, 8 /* PROPS */, ["class", "title"]),
                _createTextVNode(),
                _createElementVNode("div", _hoisted_8, [
                    _createVNode(_component_b_button, {
                        class: "me-2",
                        variant: "primary",
                        onClick: _ctx.selectAllLocations
                    }, {
                        default: _withCtx(() => [
                            _createTextVNode("Select All")
                        ]),
                        _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["onClick"]),
                    _createTextVNode(),
                    _createVNode(_component_b_button, {
                        variant: "primary",
                        onClick: _ctx.unselectAllLocations
                    }, {
                        default: _withCtx(() => [
                            _createTextVNode("Unselect All")
                        ]),
                        _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["onClick"])
                ]),
                _createTextVNode(),
                _createElementVNode("div", _hoisted_9, [
                    _withDirectives((_openBlock(), _createBlock(_component_b_form_checkbox, {
                        id: "displayValue",
                        modelValue: _ctx.selectAllByDefault,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((_ctx.selectAllByDefault) = $event)),
                        switch: ""
                    }, {
                        default: _withCtx(() => [
                            _hoisted_10
                        ]),
                        _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["modelValue"])), [
                        [
                            _directive_b_tooltip,
                            void 0,
                            void 0,
                            {
                                right: true,
                                hover: true
                            }
                        ]
                    ])
                ]),
                _createTextVNode(),
                _createCommentVNode(" Begin::Locations Modal "),
                _createTextVNode(),
                _createVNode(_component_b_modal, {
                    modelValue: _ctx.locationsModalVisible,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => ((_ctx.locationsModalVisible) = $event)),
                    id: _ctx.locationsModalId,
                    "header-bg-variant": "normal",
                    size: "md",
                    static: true
                }, {
                    title: _withCtx(() => [
                        _createTextVNode("\r\n\t\t\t\t\tLocations\r\n\t\t\t\t")
                    ]),
                    footer: _withCtx(() => [
                        _createElementVNode("div", _hoisted_13, [
                            _createVNode(_component_b_button, {
                                type: "button",
                                variant: "secondary",
                                onClick: _cache[3] || (_cache[3] = ($event) => (_ctx.locationsModalVisible = false))
                            }, {
                                default: _withCtx(() => [
                                    _hoisted_14,
                                    _createTextVNode(" Close\r\n\t\t\t\t\t\t")
                                ]),
                                _: 1 /* STABLE */
                            })
                        ])
                    ]),
                    default: _withCtx(() => [
                        _createTextVNode(),
                        _createVNode(_component_b_container, { clearfix: "" }, {
                            default: _withCtx(() => [
                                (_openBlock(), _createElementBlock("div", {
                                    class: "clearfix",
                                    key: _ctx.componentTreeKey
                                }, [
                                    _createElementVNode("div", _hoisted_11, [
                                        _createElementVNode("ul", _hoisted_12, [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.visibleComponentTree, (child, index) => {
                                                return (_openBlock(), _createBlock(_component_ComponentTreeVue, {
                                                    ref_for: true,
                                                    ref: "componentTreeVueList",
                                                    key: index,
                                                    item: child,
                                                    "measurement-type": _ctx.measurementType,
                                                    "parent-id": -1,
                                                    "selected-nodes": _ctx.query.nodes,
                                                    "onUpdate:selectedNodes": _cache[2] || (_cache[2] = ($event) => ((_ctx.query.nodes) = $event))
                                                }, null, 8 /* PROPS */, ["item", "measurement-type", "selected-nodes"]));
                                            }), 128 /* KEYED_FRAGMENT */))
                                        ])
                                    ])
                                ]))
                            ]),
                            _: 1 /* STABLE */
                        }),
                        _createTextVNode()
                    ]),
                    _: 1 /* STABLE */
                }, 8 /* PROPS */, ["modelValue", "id"]),
                _createTextVNode(),
                _createCommentVNode(" End::Locations Modal ")
            ]))
            : _createCommentVNode("v-if", true)
    ]));
}
